import { render, staticRenderFns } from "./MemberPage.vue?vue&type=template&id=3115afd3"
import script from "./MemberPage.vue?vue&type=script&lang=js"
export * from "./MemberPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports